import { useIntl } from 'react-intl';
import { Engine } from '@rossum/api-client/engines';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Button, CircularProgress } from '@rossum/ui/material';
import { AutomationBreadcrumbs } from '../../../containers/Automation/AutomationBreadcrumbs';
import { automationEnginesPath } from '../../../containers/Automation/helpers';
import { FIELD_FORM_ID } from '../constants';
import { useEngine } from '../hooks/useEngine';
import { engineBasicSettingsPath } from '../routes';

type FieldAddHeaderProps = {
  engine: Engine;
  isSaving: boolean;
  isTabular: boolean;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const FieldAddHeader = ({
  engine,
  isSaving,
  isTabular,
  ...rest
}: FieldAddHeaderProps) => {
  const intl = useIntl();

  const { data } = useEngine(engine.id);

  return (
    <Header
      {...rest}
      breadcrumbs={
        <AutomationBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'components.appBar.menu.automation.aiEngines',
              }),
              to: automationEnginesPath(),
            },
            {
              to: engineBasicSettingsPath(engine.id),
              label: data?.name ?? `${engine.id}`,
            },
            {
              label: intl.formatMessage({
                id: `features.engines.header.title.newField.${isTabular ? 'tabular' : 'header'}`,
              }),
            },
          ]}
        />
      }
      title={intl.formatMessage({
        id: `features.engines.header.title.newField.${isTabular ? 'tabular' : 'header'}`,
      })}
      description=""
      buttons={[
        <Button
          key="new_field"
          variant="contained"
          type="submit"
          form={FIELD_FORM_ID}
          startIcon={isSaving && <CircularProgress color="inherit" size={20} />}
          data-cy="submit-form"
          disabled={isSaving}
        >
          {intl.formatMessage({ id: 'features.engines.header.buttons.save' })}
        </Button>,
      ]}
    />
  );
};
